import { Route, Routes } from "react-router-dom";
import LoginController from "../controllers/LoginController";
import SignupController from "../controllers/SignupController";
import ForgotPaswordController from "../controllers/ForgotPaswordController";

export default function SharedPublicRoutes() {
    return (
        <Routes>
            <Route path="/login" element={<LoginController />} />
            <Route path="/signup" element={<SignupController />} />
            <Route path="/forgot-password" element={<ForgotPaswordController view="forgot" />} />
            <Route path="/reset-password/:token" element={<ForgotPaswordController view="reset" />} />
            {/* <Route path="*" element={<LoginController />} /> */}
        </Routes>
    );
}
